import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconExclamationCircle: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="exclamation-circle, info, warning"><circle cx="12" cy="12" r="9.25" stroke="currentColor" strokeWidth="1.5"/><path d="M12 7V13" stroke="currentColor" strokeWidth="1.5"/><circle cx="12" cy="16" r="1" fill="currentColor"/></CentralIconBase>;
};

export default IconExclamationCircle;
